<template>
  <div>
    <div v-for="(item,index) in pointList" :key="'sceneMaterialPoint'+item.id">
      <scene-material-point :pointInfo="item" :pointIndex="index" @clickMarker="clickMarker"></scene-material-point>
    </div>
  </div>
</template>

<script>
import SceneMaterialPoint from "@/views/globe/globe_marker/SceneMaterialPoint";

export default {
  name: "SceneMaterialPointEntry",
  props:['pointList'],
  components: {SceneMaterialPoint},
  methods:{
    clickMarker(pointInfo){
      this.$emit("clickMarker",pointInfo)
    }
  },

}
</script>

<style scoped>

</style>